export default __webpack_public_path__ + "static/media/pokeball.d14636ef.webp";